"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _default = _react.default.createClass({
  displayName: "CertificationBadges",
  propTypes: {
    certifications: _react.PropTypes.object.isRequired
  },
  render: function render() {
    var certifications = this.props.certifications;

    if (!certifications.size) {
      return _react.default.createElement("div", null, _react.default.createElement(_FormattedMessage.default, {
        message: "MarketplaceUI.goodDetailsPage.info.certifications.noCertifications"
      }));
    }

    return _react.default.createElement("div", null, this.props.certifications.map(function (award) {
      return _react.default.createElement(_UITooltip.default, {
        key: award.get('awardName'),
        title: award.getIn(['displayNames', _I18n.default.locale], award.get('defaultName'))
      }, _react.default.createElement(_UIImage.default, {
        className: "m-right-1 m-bottom-1",
        responsive: false,
        src: award.get('iconUrl'),
        style: {
          cursor: 'help'
        },
        width: 24
      }));
    }));
  }
});

exports.default = _default;
module.exports = exports.default;